<template>
  <div class="content">
    <div class="tableTit">
      <p class="tabtitBg"></p>
      <h6>防汛管理制度列表</h6>
      <el-button class="titBtn" type="primary" icon="el-icon-plus" @click="addClick()">新增</el-button>
      <el-button class="titBtn" type="success" @click="reset" icon="el-icon-refresh">重置</el-button>
      <!-- <el-button class="titBtn" type="success" icon="el-icon-search">搜索</el-button> -->
      <!-- <el-input class="querys" v-model.trim="dw" placeholder="防汛管理制度名称"></el-input> -->
      <addressTree @obj="objdata" @close="treeClose"></addressTree>
    </div>

    <div class='tabBody'>
      <el-table :data="tabledata" :height="tableHeight" @row-click="rowClick" highlight-current-row border row-key="id"
        :tree-props="{children: 'subList'}" :header-cell-style="{background:'rgba(49,130,222,0.1)'}">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column prop="ydbName" label="淤地坝名称" align="center"></el-table-column>
        <el-table-column prop="ydbFxglzdMc" label="防汛管理制度名称" align="center"></el-table-column>
        <el-table-column prop="ydbBbh" label="版本号" align="center"></el-table-column>
        <el-table-column prop="ydbDjqr" label="发布日期" align="center">
          <!-- <template slot-scope="scope">
       		<p>{{scope.row.data.split(' ')[0]}}</p>
       	</template> -->
        </el-table-column>
        <el-table-column prop="sta" label="状态" width="85px" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.status==1" class="zxfonte">无效</p>
            <p v-if="scope.row.status==0" class="zxfontb"><span class="fa fa-check fafongt"></span>有效</p>
          </template>
        </el-table-column>

        <el-table-column prop="" label="操作" width="130" align="center">
          <template slot-scope="scope">
            <el-button class="titBtn" type="warning" icon="el-icon-delete" circle @click="Deletes(scope.$index,scope.row)"></el-button>
            <el-button class="titBtn" type="success" icon="el-icon-edit" circle @click="edits(scope.$index,scope.row)"></el-button>
            <el-button class="titBtn" type="primary" icon="el-icon-view" circle @click="See(scope.$index,scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <zdpopup v-if="dialogVisible==true" @getcancel="Getcancel" @adddata="addData" @bjadddata="bjaddData" :mystate='Addsid'></zdpopup>

    <div class="fye">
    	<pagintion @dsydata='DsyData' @dstdata="DstData" :ToTal='total' :pageNums="pageNums"></pagintion>
    </div>
  </div>
</template>
<script>
  import { glzdList, glzdDelete } from "@/api/api";
  import addressTree from '@/components/mangement/addressTree.vue';
  import zdpopup from '../popup/zdpopup.vue';
  import pagintion from '@/components/mangement/pagintion.vue';
  export default {
    data() {
      return {
        dialogVisible: false,
        flmc: '', //制度名称
        tabledata: [],
        defaultProps: { ///tree设置
          children: 'child',
          label: 'name'
        },
        total: 0,
        tableHeight: window.innerHeight - 245,
        Addsid: [],
        value1: '',
        pageNums: null,
        pageSize: 20,
        pageNum: 1,
        flrow: '',
        parentdata: null,
        treesid: '',
        buttonStore: this.$store.state.buttonstore,
        hoverRow: null,
        dw: '',
      }
    },
    created() {

    },
    computed: {

    },
    components: {
      addressTree,
      zdpopup,
      pagintion
    },
    methods: {
      //调用接口获得防汛管理制度列表
      list(params) {
      	glzdList(params).then((res) => {
          this.total = res.total;
          this.tabledata = res.data;
      	})
      },
      Getcancel(data) {
        this.dialogVisible = data.dialogVisible;
      },
      addData(data) {
        this.dialogVisible = data.dialogVisible;
        let params={
        	pageSize: this.pageSize,
        	pageNum: this.pageNum,
        }
        this.list(params);
      },
      bjaddData(data) {
        this.dialogVisible = data.dialogVisible;
        let params={
        	pageSize: this.pageSize,
        	pageNum: this.pageNum,
        }
        this.list(params);
      },
      rowClick(row) {
        this.row = row;
      },
      reset() {
        this.dw = '';
      },
      addClick() {
        this.Addsid = [];
        this.dialogVisible = true;
        this.Addsid.push('xz');
      },
      See(index, row) {
        this.Addsid = [];
        this.dialogVisible = true;
        this.Addsid.push('ck', row);
      },
      edits(index, row) {
        this.Addsid = [];
        this.dialogVisible = true;
        this.Addsid.push('bj', row);
      },
      Deletes(index, row) {
      	this.$confirm('确定删除当前用户吗?此操作将永久删除, 是否继续?', '提示', {
      		confirmButtonText: '确定',
      		cancelButtonText: '取消',
      		type: 'warning'
      	}).then(action => {
      		if(action === 'confirm') {
            let ids = [];
            ids.push(row.id);
      			glzdDelete(ids).then((res) => {
      				if(res.code == 200) {
      					this.$notify({
      						title: "提示",
      						message: res.message,
      						type: "success",
      					});
      					let params = {
      						pageSize: this.pageSize,
      						pageNum: this.pageNum,
      					}
      					this.list(params)
      				} else {
      					this.$notify({
      						title: "提示",
      						message: res.message,
      						type: "success",
      					});
      				}
      			})
      		}
      	}).catch(() => {

      		this.$message({
      			message: '已取消',
      			type: 'warning'
      		});
      	});
      },
      treeClose() {
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        }
        this.list(params)
      },
      objdata(data) {
        let params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          ydbCode: data.ydbCode
        }
        this.list(params)
      },
      DsyData(data) { //多少页
      	this.pageNum = data.dsy;
      	let params = {
      		pageSize: this.pageSize,
      		pageNum: this.pageNum,

      	}
      	this.list(params)
      },
      DstData(data) { //多少条
      	this.pageSize = data.dst;
      	let params = {
      		pageSize: this.pageSize,
      		pageNum: this.pageNum,

      	}
      	this.list(params)
      },
    },
    mounted() {
      let params = {
      	pageSize: this.pageSize,
      	pageNum: this.pageNum,
      }
      this.list(params);
    },
    watch: {

    },
  }
</script>

<style scoped>
  @import url('../../../common/css/mangementall.css');

  .querys {
    height: 30px;
    float: right;
    width: 200px;
    margin-top: 10px;
    margin-right: 10px;
  }

  >>>.el-input__inner {
    height: 30px;
    line-height: 30px;
    color: #606266;
    padding-left: 10px;
    font-size: 14px;
  }
</style>
